import { fetchListPazirandeClubs } from "@/api/merchant/request.get";
import {
  fetchListDepositWalletPazirande,
  fetchRegisterGroup,
} from "@/api/merchant/request.post";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
import FileUploadBox from "@/shared/components/common/uploadFile";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { zodResolver } from "@hookform/resolvers/zod";
import { Grid, TextField } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { z } from "zod";

interface Props {
  onSubmitSuccess?: () => void;
  handleClickSubmit?: () => void;
}
const schema = z.object({
  club_id: z.string().optional(),
});
type FormValues = z.infer<typeof schema>;

/**
 * ContentSecondTab
 *
 * تب ثبت‌نام گروهی مشتریان. این بخش امکان بارگذاری فایل اکسل شامل اطلاعات کاربران
 * و انتخاب سازمان مشتری را فراهم می‌کند. مقادیر وارد شده پردازش شده و برای ثبت ارسال می‌شوند.
 *
 * @param onSubmitSuccess Callback برای اجرای عملیات پس از ثبت موفق
 * @param handleClickSubmit Callback برای مدیریت رفتار پس از کلیک روی ثبت
 *
 * @returns JSX.Element
 */

const ContentSecondTab: React.FC<Props> = ({ onSubmitSuccess, handleClickSubmit, }) => {

  const { data: dataListPazirandeClubs, isFetched, isLoading, } = useQuery({
    queryKey: ["ListPazirandeClubsContentSecondTab-data"],
    queryFn: fetchListPazirandeClubs,
  });

  const { mutate: submitFormRegisterGroup } = useMutation({
    mutationFn: fetchRegisterGroup,
    onSuccess: (data: any) => {
      // setListIncreaseGiftChart(data?.data?.chart)
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    },
  });
  const { control, handleSubmit, formState: { errors } } = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      club_id: "",
    },
  });

  const [clubId, setClubId] = useState("");
  const [fileExel, setFileExel] = useState<File | null>(null);
  const handleFile = (file: any) => {
    setFileExel(file);
  };
  const handleSubmitSendData = () => {
    if (fileExel instanceof File) {
      const formData = new FormData();
      formData.append("excel_file", fileExel);
      formData.append("club_id", String(clubId));

      submitFormRegisterGroup(formData); // فقط این
    } else {
      toast.error("لطفا فایل اکسل انتخاب کنید");
    }
  };

  return (
    <StackKit alignItems={"normal"} sx={{bgcolor: "#2C2C2C",width: "100%",borderRadius: "10px",padding: { xs: "10px 12px", sm: "10px 20px" },}}>
      <StackKit sx={{ width: "100%" }} alignItems={"start"}>
        <TypoGraphyKit variant="body1" sx={{ textAlign: "right" }}>
          مشخصات کاربران مورد نظر را که شامل کد ملی، شماره تلفن همراه و تاریخ تولد
          میباشد , در قالب یک فایل اکسل در این بخش بارگزاری نمایید. توجه داشته باشید
          که در هر فایل مشخصات {toPersianNumber(100)} نفر را وارد نمایید. شما میتوانید
          نمونه فایل اکسل را از اینجا دانلود کنید.
        </TypoGraphyKit>
      </StackKit>

      <Grid container gap={{ xs: 4, sm: 8 }}>
        {/* انتخاب سازمان مشتری */}
        <Grid size={12}>
          <Controller name="club_id" control={control}
            render={({ field }) => (
              <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "flex-start", sm: "center" }} alignItems={"center"} gap={2}>
                <TypoGraphyKit variant="body1" >
                  سازمان مشتری
                </TypoGraphyKit>

                <CustomSelectNormal
                  className="w-full max-w-[500px]" label="" options={dataListPazirandeClubs ?? []} getOptionLabel={(item) => `${item.title}`} getOptionValue={(item) => item.id} value={field.value || ""}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setClubId(e.target.value);
                  }} 
                />
              </StackKit>
            )}
          />
        </Grid>

        {/* آپلود فایل */}
        <Grid size={12}>
          <FileUploadBox onFileSelect={handleFile} fileExel={fileExel} setFileExel={setFileExel}/>
        </Grid>

        {/* دکمه ثبت */}
        <Grid size={12} sx={{display: "flex",justifyContent: { xs: "center", sm: "flex-end" },}}>
          <CustomButton sx={{bgcolor: "#5A5A5A",padding: { xs: "10px 20px", sm: "10px 15px" }, width: { xs: "100%", sm: "auto" },}} onClick={handleSubmitSendData}>
            <TypoGraphyKit>ثبت نهایی کاربر</TypoGraphyKit>
          </CustomButton>
        </Grid>
      </Grid>
    </StackKit>

  );
};

export default ContentSecondTab;
